export const assetCreatePage = {
  title: '新增資產',
  batchAssetModal: {
    title: '新增資產序號',
    quantity: '件數',
    seriesNumber: '序號',
  },
}
